<template>
  <form>
    <md-card>
      <md-card-header class="md-card-header-icon" :class="getClass(headerColor)">
        <div class="card-icon">
          <md-icon>lock</md-icon>
        </div>
        <h4 class="title">Shared Secret</h4>
        <help-link :link="helpLink.link" title="secret"></help-link>
      </md-card-header>
      <md-card-content>
        <div class="md-layout">
          <div class="md-layout-item md-size-100">
            <md-field>
              <label>Shared Secret</label>
              <md-input
                readonly
                v-model="app.sharedSecret"
                type="password"
                data-tour="application_shared_secret"
              ></md-input>
            </md-field>
          </div>
        </div>
      </md-card-content>
    </md-card>
  </form>
</template>
<script>
import { HelpLinkTemplate } from "@/fmComponents";
import helpLinks from '../../contextualHelpLinks.js';
export default {
  props: {
    app: null,
    ogApp: null,
    headerColor: {
      type: String,
      default: ""
    }
  },
  components: {
    'help-link': HelpLinkTemplate
  },
  data: () => ({
    helpLink: helpLinks.applicationConfig.sharedSecret
  }),
  methods: {
    getClass: function(headerColor) {
      return "md-card-header-" + headerColor + "";
    }
  }
};
</script>